shadow$provide[296] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Reveal:{enumerable:true, get:function() {
  return Reveal;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__SLASH_transition_DOT_js = require("./transition.js");
class Reveal extends require$_DOT__SLASH_transition_DOT_js.Transition {
  static initClass() {
    this.traits = ["node", "transition", "mask", "visible", "active"];
  }
  mask(shader) {
    let left, s;
    if (shader) {
      s = this._shaders.shader();
      s.pipe(UGLSL.identity("vec4"));
      s.fan();
      s.pipe(shader, this.uniforms);
      s.next();
      s.pipe("reveal.mask", this.uniforms);
      s.end();
      s.pipe("float combine(float a, float b) { return min(a, b); }");
    } else {
      s = this._shaders.shader();
      s.pipe("reveal.mask", this.uniforms);
    }
    return (left = __guard__(this._inherit("mask"), x => x.mask(s))) != null ? left : s;
  }
}
Reveal.initClass();
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

};